import React from 'react'
import classnames from 'classnames'
import { css } from 'linaria'

import { Column } from '../layout/Column.react'

const ascending = css``
const descending = css``
const orderable = css`
  cursor: pointer;
  &:hover {
    text-decoration: underline;
  }

  .${ascending} {
    &:after {
      content: "\\25b2" // triangle facing up
    }
  }

  .${descending} {
    &:after {
      content: "\\25bc"; // triangle facing down
    }
  }
`

export const ColumnHeader = ({ title, changeSortFn = null, isAscending = null, isDescending = null, sortBy = false, width = 20, children, ...columnProps }) => {
  if (sortBy && changeSortFn) {
    columnProps = Object.assign(columnProps, {
      className: orderable,
      onClick: () => changeSortFn(sortBy)
    })
  }

  return (
    <Column width={width} role='columnheader' data-testid='ColumnHeader' {...columnProps}>
      <span>{title}</span>&nbsp;
      {(sortBy && isAscending && isDescending) &&
        <span
          className={classnames({
            [ascending]: isAscending(sortBy),
            [descending]: isDescending(sortBy)
          })}
        />}
      {children}
    </Column>
  )
}
